import BaseApi from "./baseApi";
import type { IdLike } from "../types";

class ParishCategoryApi extends BaseApi {
  async addCategory(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/parish-categories/add",
      data: data,
      method: "post",
    });
  }

  async getAllCategories(): Promise<any> {
    return await this.API({
      url: "/parish-categories/list",
      method: "get",
    });
  }

  async getCategory(id: IdLike): Promise<any> {
    return await this.API({
      url: `/parish-categories/${id}`,
      method: "get",
    });
  }

  async updateCategory(data: Record<string, unknown> | object, id: IdLike): Promise<any> {
    return await this.API({
      url: `/parish-categories/update/${id}`,
      data: data,
      method: "put",
    });
  }

  async deleteCategory(data: Record<string, unknown> | object, id: IdLike): Promise<any> {
    return await this.API({
      url: `/parish-categories/delete/${id}`,
      data: data,
      method: "delete",
    });
  }

  async searchCategory(key: string): Promise<any> {
    return await this.API({
      url: `/parish-categories/search/${key}`,
      method: "get",
    });
  }
}

export default ParishCategoryApi;
